import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ResponseDialogComponent } from '../response-dialog/response-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { PuzzleService } from 'src/app/services/puzzle.service';
import { Company } from 'src/app/interfaces/company';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ResponseSmallDialogComponent } from '../response-small-dialog/response-small-dialog.component';

@Component({
  selector: 'app-upload-csf-dialog',
  templateUrl: './upload-csf-dialog.component.html',
  styleUrls: ['./upload-csf-dialog.component.css']
})
export class UploadCsfDialogComponent implements OnInit {

  selectedFile: File | null = null;
  sending = false;
  companyId: string = '';
  fileName: string = 'Constancia de situación fiscal';

  constructor(
    public dialog: MatDialog,
    private translate: TranslateService,
    private puzzleService: PuzzleService,
    private dialogRef: MatDialogRef<UploadCsfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.companyId = data.company?.comP_ID;
    if (data.fileName) {
      this.fileName = data.fileName;
    }
  }

  ngOnInit(): void {
  }

  removeFile() {
    this.selectedFile = null;
  }

  // Maneja el evento de selección de archivo
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.validateFile();
    }
    // resetear el input
    input.value = '';
  }

  // Maneja el evento de arrastrar y soltar archivos
  onFileDropped(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer?.files;
    if (files?.length) {
      this.selectedFile = files[0]; // Solo permite un archivo
      this.validateFile();
    }
    const dropzone = event.currentTarget as HTMLElement;
    dropzone.classList.remove('dragover');
  }

  validateFile() {
    if (this.selectedFile) {
      // validar .pdf, .jpg, .jpeg, .png, .doc, .docx de hasta 10MB
      const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.docx', '.xlsx'];
      const allowedSize = 10 * 1024 * 1024; // 10MB en bytes
      const extension = this.selectedFile.name.split('.').pop().toLowerCase();

      if (allowedExtensions.includes(`.${extension?.toLowerCase()}`) && this.selectedFile.size <= allowedSize) {
      } else {
        this.selectedFile = null;
        this.openResponseDialog('Error', this.translate.instant('uploadCsfDialogErrorValidation'));
        return;
      }

      // si inicia con ~$ y pesa menos de 500 bytes, es un archivo temporal de office
      if (/* this.selectedFile.name.startsWith('~$') &&  */this.selectedFile.size < 500) {
        let title = this.translate.instant("extErrorTempFile")
        let message = "<br>" + this.selectedFile.name + "<br><br>" + this.translate.instant("extErrorTempFileMessage");
        this.selectedFile = null;
        this.openResultDialog(0, title, message);
        return;
      }
      
      // si es word abrir dialogo de confirmacion
      if (extension == 'doc' || extension == 'docx') {
        let dialog = this.openConfirmDialog();
      }
    }
  }

  openResultDialog(mode: number, message?: string, content?: string) {
      let data: string[] = [];
      switch (mode) {
        case 0:
          {
            data.push('Error');
            data.push(message);
            if (content) data.push(content);
            return this.dialog.open(ResponseSmallDialogComponent, {
              width: '500px',
              data: data,
            });
          }
          break;
        case 1:
          {
            data.push('Exito');
            data.push(message);
            if (content) data.push(content);
  
            return this.dialog.open(ResponseSmallDialogComponent, {
              width: '500px',
              data: data,
            });
          }
          break;
        case 2:
          {
            data.push('loading');
            data.push(message);
            if (content) data.push(content);
  
            return this.dialog.open(ResponseSmallDialogComponent, {
              width: '500px',
              data: data,
              disableClose: true
            });
          }
          break;
      }
    }

  openConfirmDialog() {
    let data = [];
    const title = this.translate.instant('wordFileToPDF');
    const confirmMessage = this.translate.instant('wordFileToPDFMessage');

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: [title, confirmMessage],
    });

    return dialogRef;
  }

  // Evita el comportamiento por defecto en el dragover
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    // Añadir clase cuando el archivo esté sobre el área
    const dropzone = event.currentTarget as HTMLElement;
    dropzone.classList.add('dragover');
  }

  // Maneja el evento dragleave (opcional)
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    // Remover clase cuando el archivo ya no esté sobre el área
    const dropzone = event.currentTarget as HTMLElement;
    dropzone.classList.remove('dragover');
  }

  // Simula el proceso de subida de archivo
  uploadFile(): void {
    if (!this.selectedFile || this.sending) return;

    this.sending = true;

    const formData = new FormData();
    formData.append('CompanyId', this.companyId);
    formData.append('CsfFile', this.selectedFile);

    this.puzzleService.uploadCompanyCSF(formData).subscribe(
      (response) => {
        this.sending = false;
        if (response.isSuccess) {
          this.openResponseDialog('Exito', this.translate.instant(response.message));
          this.dialogRef.close(true);
        } else {
          this.openResponseDialog('Error', this.translate.instant('uploadCsfDialogError'), this.fileName);
        }
      },
      (error) => {
        this.sending = false;
        this.openResponseDialog('Error', this.translate.instant('uploadCsfDialogError'), this.fileName);
      }
    );
  }

  openResponseDialog(response: string, message?: string, name?: string) {
    let data: string[] = [];
    if (response == 'Error') {
      data.push('Error');
      data.push(message);
      if (name) data.push(name);
      const dialogRef = this.dialog.open(ResponseDialogComponent, {
        width: '500px',
        /* height: '400px', */
        data: data,
      });
    } else if (response == 'Exito') {
      data.push('Exito');
      data.push(message);

      const dialogRef = this.dialog.open(ResponseDialogComponent, {
        width: '500px',
        /* height: '400px', */
        data: data,
      });
    }
  }
}

